import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
export const TransferToBlind = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  return /*#__PURE__*/React.createElement("span", null, linkToAccount(op[1].from), "\xA0", /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: fromComponent === "proposed_operation" ? "proposal.sent" : "transaction.sent"
  }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
    style: {
      fontWeight: "bold"
    },
    amount: op[1].amount.amount,
    asset: op[1].amount.asset_id
  }));
};